import React, { Suspense } from "react";
import Layout from "../layouts";
import Loading from "../components/loading";
import { RouteProps, routes } from "./routes";
import { Route, Routes } from "react-router-dom";

export default function CustomRoutes() {
  return (
    <Layout>
      <Routes>
        {routes.map(({ path, component }: RouteProps) => {
          return (
            <Route
              key={path}
              path={path}
              element={<Suspense fallback={<Loading />}>{component}</Suspense>}
            />
          );
        })}
      </Routes>
    </Layout>
  );
}